export const handleLogoutEmbed = (): void => {
  return window?.parent?.postMessage('logout', '*')
}

export const handleManyRequestsRefreshToken = (): void => {
  return window?.parent?.postMessage('manyRequests', '*')
}
